export var RESTAURANT_WEEKDAYS = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
];
export var RESTAURANT_WEEKDAY_LABELS = {
    monday: 'Понедельник',
    tuesday: 'Вторник',
    wednesday: 'Среда',
    thursday: 'Четверг',
    friday: 'Пятница',
    saturday: 'Суббота',
    sunday: 'Воскресенье',
};
export var emptyRestaurantWorkingHours = function () {
    return RESTAURANT_WEEKDAYS.reduce(function (acc, day) {
        acc[day] = { closed: false, open: '', close: '' };
        return acc;
    }, {});
};
export var normalizeRestaurantWorkingHours = function (value) {
    var _a, _b;
    var base = emptyRestaurantWorkingHours();
    if (!value)
        return base;
    for (var _i = 0, RESTAURANT_WEEKDAYS_1 = RESTAURANT_WEEKDAYS; _i < RESTAURANT_WEEKDAYS_1.length; _i++) {
        var day = RESTAURANT_WEEKDAYS_1[_i];
        var schedule = value[day];
        if (!schedule)
            continue;
        base[day] = {
            closed: Boolean(schedule.closed),
            open: (_a = schedule.open) !== null && _a !== void 0 ? _a : '',
            close: (_b = schedule.close) !== null && _b !== void 0 ? _b : '',
        };
    }
    return base;
};
export var serializeRestaurantWorkingHours = function (value) {
    var _a, _b;
    var result = {};
    for (var _i = 0, RESTAURANT_WEEKDAYS_2 = RESTAURANT_WEEKDAYS; _i < RESTAURANT_WEEKDAYS_2.length; _i++) {
        var day = RESTAURANT_WEEKDAYS_2[_i];
        var schedule = value[day];
        if (!schedule)
            continue;
        var closed = Boolean(schedule.closed);
        var open = ((_a = schedule.open) !== null && _a !== void 0 ? _a : '').trim();
        var close = ((_b = schedule.close) !== null && _b !== void 0 ? _b : '').trim();
        if (closed || open || close) {
            result[day] = {
                closed: closed,
                open: closed ? null : open || null,
                close: closed ? null : close || null,
            };
        }
    }
    return Object.keys(result).length > 0 ? result : null;
};
